"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageInformationInternal = getLanguageInformationInternal;
exports.getLanguageInformationForDescription = getLanguageInformationForDescription;
const rpc = __importStar(require("vscode-jsonrpc/node"));
const connect_1 = __importDefault(require("../connect"));
/**
 * Retrieves language information by connecting to Kiota.
 *
 * This function establishes a connection to Kiota and sends a request to retrieve
 * language information. If the request is successful, it returns the language information.
 * If an error occurs during the request, the error is thrown.
 *
 * @returns {Promise<LanguagesInformation | undefined>} A promise that resolves to the language information or undefined if an error occurs.
 * @throws {Error} Throws an error if the request fails.
 */
async function getLanguageInformationInternal() {
    const result = await (0, connect_1.default)(async (connection) => {
        const request = new rpc.RequestType0("Info");
        return await connection.sendRequest(request);
    });
    if (result instanceof Error) {
        throw result;
    }
    return result;
}
;
/**
 * Retrieves language information based on the provided description URL.
 *
 * @param {LanguageInformationConfiguration} config - The configuration object containing the description URL and cache clearing option.
 * @param {string} config.descriptionUrl - The URL of the description to retrieve language information for.
 * @param {boolean} config.clearCache - A flag indicating whether to clear the cache before retrieving the information.
 *
 * @returns {Promise<LanguagesInformation | undefined>} A promise that resolves to the language information or undefined if an error occurs.
 *
 * @throws {Error} Throws an error if the request fails.
 */
async function getLanguageInformationForDescription({ descriptionUrl, clearCache }) {
    const result = await (0, connect_1.default)(async (connection) => {
        const request = new rpc.RequestType2("InfoForDescription");
        return await connection.sendRequest(request, descriptionUrl, clearCache);
    });
    if (result instanceof Error) {
        throw result;
    }
    return result;
}
;
//# sourceMappingURL=languageInformation.js.map